import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const ConditionLeftMenu = ({ sectionList, visibleSection }) => {
  // eslint-disable-next-line no-unused-vars
  const handleScrollNew = (e, elementId, isFocus) => {
    e.preventDefault();
    if (typeof window !== 'undefined') {
      window.history.pushState(
        {},
        `condition-treatment${elementId}`,
        `${window.location.pathname}#${elementId}`
      );
    }
    document
      .getElementById(elementId)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
    _.setFocusWithoutReload(`#${elementId}`, 'a');
  };

  return (
    <section className="LeftNav">
      <div className="sc-legal-toc" role="complementary">
        <ul>
          {sectionList &&
            sectionList.map((item, index) => {
              const value = item.id.replace(' ', '-');
              return (
                <li key={index}>
                  <a
                    onClick={e => handleScrollNew(e, value, false)}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        handleScrollNew(e, value, true);
                      }
                    }}
                    href={`#${value}`}
                    className={visibleSection === item.value ? 'current' : ''}
                  >
                    {item.value}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    </section>
  );
};
ConditionLeftMenu.propTypes = {
  sectionList: PropTypes.array,
  visibleSection: PropTypes.string
};

ConditionLeftMenu.defaultProps = {
  sectionList: [],
  visibleSection: ''
};

export default ConditionLeftMenu;
